(function($) {
    $.fn.adaptiveNavigation = function() {
        var $cloneOfOriginalNav = $('.navbar-nav').clone(),
            currentMode = 'desktop',
            mq = window.matchMedia('(max-width: 991px)'),

            widthChange = function() {
                if (mq.matches) {
                    if (currentMode === 'desktop') {
                        switchToMobileMode();
                    }
                } else {
                    if (currentMode !== 'desktop') {
                        switchToDesktopMode();
                    }
                }
            },

            switchToDesktopMode = function() {
                $('.sliding-mobile-menu').replaceWith($cloneOfOriginalNav.clone());
                currentMode = 'desktop';
            },

            switchToMobileMode = function() {
                var $slidingMobileMenu = $('.navbar-nav').addClass('sliding-mobile-menu');

                createLanguageSpecificBackButtons();
                substituteDropdownSpecificClasses();
                handleClosureOfSubMenu();
                handleActivationOfSubMenu();
                defineTrueSubSubMenus();
                handleActivationOfSubSubMenuFromLink();
                createDropdownParents();
                handleActivationOfSubSubMenuFromLinkThatWasSpan();
                ensureBackButtonsAreFirstItem();
                ensureMenuHeightIsCorrect();
                currentMode = 'mobile';

                function createLanguageSpecificBackButtons() {
                    var label = $().isWelshPage() ? 'Eitem un. Yn ôl i\'r ddewislen flaenorol' : 'Item one. Back to previous menu',
                        linkText = $().isWelshPage() ? 'Yn ôl' : 'Back';
                    $slidingMobileMenu.find('.primary-nav-panel-content, .dropdown-menu ul li ul').prepend(`<li class="nav-item sub-close-li"><a class="sub-close" href="#" aria-label="${label}">${linkText}</a></li>`);
                }

                function substituteDropdownSpecificClasses() {
                    $slidingMobileMenu.find('.dropdown').addClass('slider-dropdown').removeClass('dropdown');
                    $slidingMobileMenu.find('.dropdown-menu').addClass('slider-dropdown-menu').removeClass('dropdown-menu');
                    $slidingMobileMenu.find('.dropdown-item').addClass('slider-dropdown-item').removeClass('dropdown-item');
                    $slidingMobileMenu.find('.dropdown-toggle').addClass('slider-dropdown-toggle').removeClass('dropdown-toggle');
                }

                function handleClosureOfSubMenu() {
                    $('.sub-close').on('click', function(e) {
                        e.preventDefault();
                        $(this).parent().parent().removeClass('is-active');
                    });
                }

                function handleActivationOfSubMenu() {
                    $('li.slider-dropdown > a').on('click', function(e) {
                        e.preventDefault();
                        $(this).parent().find('.primary-nav-panel-content').addClass('is-active');
                    });
                }

                function defineTrueSubSubMenus() {
                    $('.nav-item').each(function() {
                        if ($(this).children('ul').length > 0) {
                            $(this).addClass('has-child-ul');
                        }
                    });
                }

                function handleActivationOfSubSubMenuFromLink() {
                    $('.primary-nav-panel-content-submenu-header').filter(function() {
                        return $(this).parent().find('ul').length > 0;
                    }).on('click', function(e) {
                        e.preventDefault();
                        $(this).parent().find('ul').addClass('is-active');
                    });
                }

                function handleActivationOfSubSubMenuFromLinkThatWasSpan() {
                    $('.primary-nav-panel-content-submenu-header-plain').filter(function() {
                        return $(this).parent().find('ul').length > 0;
                    }).on('click', function(e) {
                        e.preventDefault();
                        $(this).parent().find('ul').addClass('is-active');
                    });
                }

                function createDropdownParents() {
                    var $filteredDropDownParent = $('.slider-dropdown-menu li.nav-item').filter(function() {
                        return $(this).find('ul').length !== 0;
                    });

                    $filteredDropDownParent
                        .each(function() {
                            // panel submenu headings that are also links
                            $(this).find('a.primary-nav-panel-content-submenu-header').each(function() {
                                var $this = $(this),
                                    href = $this.attr('href'),
                                    linkText = $this.text();

                                $this
                                    .next('ul')
                                    .prepend(`<li class="nav-item primary-nav-panel-content-submenu-link"><a href="${href}" class="nav-link">${linkText}</a></li>`)
                                    .prev()
                                    .attr('href', '#');
                            });
                        })
                        .each(function() {
                            // panel submenu headings that are *not* links
                            $(this).find('span.primary-nav-panel-content-submenu-header-plain').each(function() {
                                var $this = $(this),
                                    linkText = $this.text(),
                                    classes = $this.attr('class');

                                $this
                                    .next('ul')
                                    .prev()
                                    .replaceWith(`<a role="menuitem" href="#" class="${classes} nav-link" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">${linkText}</a>`);
                            });
                        });
                }

                function ensureBackButtonsAreFirstItem() {
                    $('.sub-close-li').each(function() {
                        $(this).parent().prepend(this);
                    });
                };

                function ensureMenuHeightIsCorrect() {
                    $('.navbar-nav *').on('click', function(e) {
                        var $navbarNav = $('.navbar-nav'),
                            $activeMenu = $('.sliding-mobile-menu ul li ul.is-active');
                        $($navbarNav).height($activeMenu.height());
                    });
                };
            };

        $('li.dropdown').last().addClass('dropdown-right');

        if (matchMedia) {
            mq.addListener(widthChange);
            widthChange(mq);
        }
        return this;
    };
}(jQuery));
